import { createContext } from "react";

const serviceContext = createContext({
  serviceItems: [false],
  setServiceItems: (items) => {}
});

export default serviceContext;
